<script>
import substanceDictionaries from "@core/mixins/substance-dictionaries";
import { BCardTitle, BListGroup, BListGroupItem, BBadge, BFormRadio, BCard, BRow, BCol, BFormGroup, BButton,
    BFormInput } from 'bootstrap-vue'
import vSelect from 'vue-select'
import { VueAutosuggest } from 'vue-autosuggest'
import {SubstanceLists} from "@/libs/substance";
import {RegulatedPropertyType} from "@core/domain/substance";
import {ProductCategorySelect} from "@core/components/product";
import GeneralProductStatements
    from "@/views/administration/substance/regulated-substances/regulated-properties/GeneralProductStatements.vue";
import TreeSelect from "@core/components/common/TreeSelect.vue";

export default {
    mixins: [substanceDictionaries],
    components: {
        GeneralProductStatements,
        ProductCategorySelect,
        BCard, BButton, BRow, BCol, BFormGroup, BCardTitle,
        BFormInput, VueAutosuggest, vSelect, BBadge, BFormRadio, BListGroup, BListGroupItem, TreeSelect
    },
    props: {
        readOnly: {
            default: false,
        },
        compactView: {
            default: false
        },
        isMaterialCategoryMandatory: {
            type: Boolean,
            default: true
        },
        properties: {
            required: true,
            type: Object,
        }
    },
    data() {
        return {
            materialCategory: [],
            mixtureCategory: [],
            statements: [],
            productCategories: [],

            suggestions: [],
            searchTimer: null,
            generalProductStatements: []
        };
    },
    methods: {
        normalize(node) {
            return {id: node.id, label: node.title};
        },

        onMaterialCategoryChange(value) {
            this.materialCategory = value;
            this.emit();
        },

        onMixtureCategoryChange(value) {
            this.mixtureCategory = value;
            this.emit();
        },

        onProductCategoryChange({idList, items}) {
            this.productCategories = items.map(c => c.category);
            this.emit();
        },

        addStatement(statement) {
            this.statements.push(statement);
            this.emit();
        },

        removeStatement(statement) {
            const index = this.statements.findIndex(s => s.statement.id === statement.statement.id);

            if (index >= 0) {
                this.statements.splice(index, 1);
                this.emit();
            }
        },

        emit() {
            const data = {};
            data[RegulatedPropertyType.PRODUCT_CATEGORY] = this.productCategories;
            data[RegulatedPropertyType.MIXTURE_CATEGORY] = this.mixtureCategory;
            data[RegulatedPropertyType.MATERIAL_CATEGORY] = this.materialCategory;
            data[RegulatedPropertyType.GENERAL_PRODUCT_STATEMENTS] = this.statements;

            this.$emit('change', SubstanceLists.REACH_ANN_17, data);
        },
    },
    created() {
        this.initSubstanceDictionaries();
    },
    watch: {
        properties() {
            if (this.properties[RegulatedPropertyType.MATERIAL_CATEGORY]) {
                this.materialCategory = this.properties[RegulatedPropertyType.MATERIAL_CATEGORY];
            }
            if (this.properties[RegulatedPropertyType.MIXTURE_CATEGORY]) {
                this.mixtureCategory = this.properties[RegulatedPropertyType.MIXTURE_CATEGORY];
            }
            if (this.properties[RegulatedPropertyType.GENERAL_PRODUCT_STATEMENTS]) {
                this.statements = this.properties[RegulatedPropertyType.GENERAL_PRODUCT_STATEMENTS];
            }
            if (this.properties[RegulatedPropertyType.PRODUCT_CATEGORY]) {
                this.productCategories = this.properties[RegulatedPropertyType.PRODUCT_CATEGORY];
            }
        }
    }
}
</script>

<template>
    <div>
        <b-row v-if="compactView">
            <b-col>
                <b-row>
                    <b-col>
                        <b-form-group :label="$t('Component(CompositionSubstance):mixture-category')">
                            <TreeSelect
                                :options="mixtureCategories"
                                :title="$t('Component(CompositionSubstance):hover-mixture-category')"
                                :placeholder="$t('Component(CompositionSubstance):mixture-category-placeholder')"
                                :value="mixtureCategory"
                                @input="onMixtureCategoryChange"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group :label="$t('Component(CompositionSubstance):material-category')">
                            <TreeSelect
                                :options="materialCategories"
                                :title="$t('Component(CompositionSubstance):hover-material-category')"
                                :placeholder="$t('Component(Placeholder):select-or-search')"
                                :value="materialCategory"
                                @input="onMaterialCategoryChange"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row v-else>
            <b-col md="5" lg="5">
                <b-row>
                    <b-col>
                        <b-form-group :label="$t('Component(CompositionSubstance):mixture-category')">
                            <TreeSelect
                                :options="mixtureCategories"
                                :title="$t('Component(CompositionSubstance):hover-mixture-category')"
                                :placeholder="$t('Component(CompositionSubstance):mixture-category-placeholder')"
                                :value="mixtureCategory"
                                @input="onMixtureCategoryChange"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-col>
            <b-col md="7" lg="7">
                <b-row>
                    <b-col>
                        <b-form-group :label="$t('Component(CompositionSubstance):material-category')">
                            <TreeSelect
                                :options="materialCategories"
                                :title="$t('Component(CompositionSubstance):hover-material-category')"
                                :placeholder="$t('Component(Placeholder):select-or-search')"
                                :value="materialCategory"
                                @input="onMaterialCategoryChange"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <ProductCategorySelect
                    title="Product categories"
                    @change="onProductCategoryChange"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <GeneralProductStatements
                    :statements="statements"
                    @removeStatement="removeStatement"
                    @newStatement="addStatement"
                />
            </b-col>
        </b-row>
    </div>
</template>
